<template>
  <div class="page-VirtualHall">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      @check="getVideo"
    >
      <div
        v-for="(item, idx) in list"
        :key="idx"
        class="innerContent"
        @click="hanldeClick(idx)"
      >
        <van-image
          width="100%"
          height="230"
          fit="cover"
          :src="item.smallImage"
          class="page-VirtualHall_img"
        />
        <div class="page-VirtualHall_imgTitle">{{ item.title }}</div>
      </div>
    </van-list>
  </div>
</template>

<script>
// 接口noeId传267 得视频数据
import { getAllNewsUrl } from "@culturalRelicsUrl";
import http from "@js/http-ww.js";
import { List, Image as VanImage } from "vant";
export default {
  data() {
    return {
      loading: false,
      list: [],
      finished: false,
      requestParams: {
        nodeId: 267,
        page: -1,
        size: 1,
      },
    };
  },
  mounted() {},
  methods: {
    getVideo() {
      this.requestParams.page++;
      http
        .get(getAllNewsUrl, {
          params: {
            ...this.requestParams,
          },
        })
        .then(
          ({
            data: {
              data: { page },
              status,
            },
          }) => {
            if (status) {
              this.list.push(page.content[0]);
              this.totalPage = page.totalPages;
              this.loading = false;
              if (this.requestParams.page == this.totalPage - 1) {
                this.finished = true;
              }
            }
          }
        );
    },
    hanldeClick(i) {
      switch (i) {
        case 0:
          window.location.href =
            "https://720yun.com/t/b1vksydl5pq?scene_id=46159444";
          break;

        case 1:
          window.location.href =
            "http://www.hainanmuseum.org/cms/1/virtual/VirtualHall/";
          break;
        case 2:
          window.location.href =
            "http://www.hainanmuseum.org/cms/1/virtual/kp/VirtualHall/index.html";
          break;
        case 3:
          window.location.href =
            "http://www.hainanmuseum.org/cms/1/virtual/kp/tcxy/index.html";
          break;
      }
    },
    onLoad() {
      this.getVideo();
    },
  },
  components: {
    [List.name]: List,
  },
};
</script>

<style lang="less" scoped>
.page-VirtualHall {
  padding: 20px;
  box-sizing: border-box;
  .innerContent {
    position: relative;
    margin-bottom: 30px;
    .page-VirtualHall_img {
      /deep/img {
        width: 93%;
        height: 100%;
        margin: 0 auto;
      }
    }
    .page-VirtualHall_imgTitle {
      position: absolute;
      left: 0;
      bottom: -24px;
      z-index: 99;
      width: 100%;
      height: 51px;
      background: url("../../assets/hb-img63.png") no-repeat center;
      background-size: cover;
      text-align: center;
      color: #fff;
      line-height: 40px;
      font-family: "hyxlFont";
    }
  }
}
</style>